import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { buildMobileHandoffUrl } from '~/constants/mobileApp';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

type UseMobileHandoffUrlOptions = {
  workspaceId?: string;
};

export const useMobileHandoffUrl = ({
  workspaceId: workspaceIdOverride,
}: UseMobileHandoffUrlOptions = {}): string | null => {
  const router = useRouter();
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = workspaceIdOverride ?? currentWorkspace?.id;
  const hasHandoffContext = router.isReady && Boolean(workspaceId) && Boolean(router.asPath);

  return useMemo(() => {
    if (!hasHandoffContext || !workspaceId) {
      return null;
    }

    return buildMobileHandoffUrl({ workspaceId, returnTo: router.asPath });
  }, [hasHandoffContext, router.asPath, workspaceId]);
};
